// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30Uuh","col":"styles_col__1kJbW"};